// extracted by mini-css-extract-plugin
export default {"industry":"industry_industry__UYGbx","verticalLine":"industry_verticalLine__xDIo5","industryTable":"industry_industryTable__2-j8n"};